import { fade } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/core/styles';

const Styles = makeStyles(theme => ({
  root: {
    // flexGrow: 1
    display: 'flex',
  },
  paper: {
    marginRight: '2px',
  },
  navbar: {
    height: '80px',
    boxShadow: 'none',
  },
  toolbar: {
    minHeight: '80px',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.contrastText,
  },
  linkHeader: {
    color: theme.palette.primary.contrastText,
    '&:hover': {
      color: theme.palette.secondary.light,
    },
  },
  headerButton: {
    fontSize: '1em',
    color: theme.palette.primary.contrastText,
    borderBottom: `solid 4px ${theme.palette.primary.main}`,
    borderRadius: 0,
    minHeight: 30,
    '&:hover': {
      color: theme.palette.secondary.light,
      backgroundColor: theme.palette.primary.main,
      borderBottomColor: theme.palette.primary.contrastText
    },
    '&__selected': {
      fontSize: '1em',
      color: theme.palette.primary.contrastText,
      borderBottom: `solid 4px ${theme.palette.secondary.main}`,
      cursor: 'default',
      borderRadius: 0,
      minHeight: 30,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      }
    }
  },
  menuButton: {
    // marginRight: theme.spacing(2),
    color: '#000000',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.5)',
      backgroundColor: 'none',
    },
  },
  title: {
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
  logo: {
    width: '61px',
    float: 'left',
    marginRight: '10px',
  },
  inlineFlex:
  {
    display: 'inline-flex'
  },
  drawer: {
    backgroundColor: theme.palette.primary.main
  }
}));
export default Styles;
